(function ($) {
    if ($('.block--image-article').length > 0) {
        $(".more-button").on('click', function() {
            $(this).parent().addClass('open');
        });

        $(".close-button").on('click', function() {
            $(this).parent().removeClass('open');
        });
    }
})(jQuery);